import React from "react";

const Dropdown = ({
    id,
    value,
    options,
    onChange,
    placeholder = "Select an option",
    className = ""
}) => {
    return (
        <select
            id={id}
            value={value}
            onChange={onChange}
            className={`flex w-full rounded-md border-gray-200 cursor-pointer px-3 py-2 pr-9 text-sm  capitalize shadow-sm focus:border-blue-500 focus:ring-blue-500 md:w-fit ${className}`}
        >
            <option value="">{placeholder}</option>
            {options.map((option) => (
                <option key={option} value={option} className="capitalize text-neutral-900">
                    {option}
                </option>
            ))}
        </select>
    );
};

export default Dropdown;